import { jsxs as I, jsx as f } from "react/jsx-runtime";
import h from "classnames";
import { useMemo as z, useCallback as d } from "react";
import { getDayClassName as J } from "./index.es2483.js";
import { useDatePicker as Q } from "./index.es851.js";
import { subMonths as U, isSameDay as W } from "date-fns";
import { useDatePanelView as Z } from "./index.es5867.js";
import n from "./index.es5868.js";
import { onKeyDownArrows as ee } from "./index.es527.js";
import { onKeyDownTab as te } from "./index.es529.js";
import { DatePanelHeader as ae } from "./index.es5861.js";
import { onKeyDownEnterAndSpace as re } from "./index.es526.js";
import { MenuText as se } from "./index.es508.js";
const Re = ({
  position: t,
  calendar: l,
  viewValue: M,
  classnames: $,
  incrementOrDecrementMonth: b,
  weekDays: k,
  dayButton: v,
  onViewChange: y
}) => {
  const {
    id: A,
    minDate: K,
    maxDate: m,
    variant: S,
    TODAY: F,
    selectedRangeData: j,
    activePanel: R,
    focusedDateLeft: P,
    focusedDateRight: w,
    setFocusedDateLeft: H,
    setFocusedDateRight: L,
    handleDateNavigation: N,
    leftPanelDayRefs: u,
    rightPanelDayRefs: D,
    leftDateRangeHeaderRef: V,
    rightDateRangeHeaderRef: E,
    focusFirstDateInPanel: x,
    focusFooterAction: T
  } = Q(), { dateRefs: g } = Z({
    position: t,
    calendar: l,
    focusedDateLeft: P,
    focusedDateRight: w,
    setFocusedDateLeft: H,
    setFocusedDateRight: L,
    selectedRangeData: j,
    TODAY: F,
    leftPanelDayRefs: u,
    rightPanelDayRefs: D
  }), G = `datepicker-date-matrix-${t}`, O = h(n.rangePanelBody, $), _ = z(() => t === "left" && m ? U(m, 1) : m, [t, m]), B = d(
    (e) => {
      y(e, t), t === "right" && R === "date-range" && setTimeout(() => {
        x("left");
      }, 100);
    },
    [x, y, t, R]
  ), X = d(
    (e, a, r) => {
      const c = e.toISOString();
      if (a) {
        g.current.set(c, a);
        const o = t === "left" ? u : D;
        o.current[r] = a;
      } else {
        g.current.delete(c);
        const o = t === "left" ? u : D;
        o.current[r] = null;
      }
    },
    [g, t, u, D]
  ), p = d((e) => {
    e.target.click();
  }, []), C = d(
    (e, a) => {
      if (t === "right" && !e.shiftKey) {
        const r = l.days.filter((s) => s.inCurrentMonth);
        r.findIndex(
          (s) => s.$date.getTime() === a.$date.getTime()
        ) === r.length - 1 && T(0);
      }
    },
    [t, l.days, T]
  ), i = d(
    (e, a) => {
      N(e.$date, a, t, l.days);
    },
    [N, t, l.days]
  ), Y = d(
    (e, a) => {
      ee(
        e,
        {
          up: () => i(a, "up"),
          down: () => i(a, "down"),
          left: () => i(a, "left"),
          right: () => i(a, "right")
        },
        !0
      ), re(e, () => p(e), !0), te(e, () => C(e, a), !1);
    },
    [i, p, C]
  ), q = h(n.rangePanelView, {
    [n.collapsed]: S === "collapsed"
  });
  return /* @__PURE__ */ I("div", { className: q, children: [
    /* @__PURE__ */ f(
      ae,
      {
        ref: t === "left" ? V : E,
        dpValue: M,
        onChange: B,
        incrementOrDecrementMonth: b,
        minDate: K,
        maxDate: _,
        position: t,
        id: A
      }
    ),
    /* @__PURE__ */ I("div", { className: O, "data-testid": G, children: [
      /* @__PURE__ */ f("div", { className: n.daysGrid, children: k.map((e) => /* @__PURE__ */ f(se, { color: "primary", variant: "regular", children: e.slice(0, 2) }, e)) }),
      /* @__PURE__ */ f("div", { className: n.daysGrid, children: l.days.map((e, a) => {
        const r = e.selected && e.range === "", c = t === "left" ? P : w, o = c && W(e.$date, c);
        return /* @__PURE__ */ f(
          "button",
          {
            ref: (s) => X(e.$date, s, a),
            className: h(
              J(n.daysGridItem + " day ", e),
              { [n.justClicked]: r }
            ),
            ...v(e),
            "aria-selected": void 0,
            tabIndex: o ? 0 : -1,
            "aria-label": `Select ${e.day}`,
            onKeyDown: (s) => Y(s, e),
            children: e.day
          },
          e.$date.toString()
        );
      }) })
    ] })
  ] });
};
export {
  Re as DatePanelView
};
//# sourceMappingURL=index.es5724.js.map
